import { Context } from "@nuxt/types";

export default function ({ store, redirect, route, app }: Context) {
  if (!store.getters["auth/isLoggedIn"]) {
    redirect(app.localePath("/appointment/signup"), { from: route.path });
  }
}
